export enum BranchEnum {
  BRANCH_SCHEDULE_WHATSAPP_BUTTON = 'branch-schedule-whatsapp-button',
  BUTTON_SHOW_MORE_SPECIALTIES = 'branch-specialties-show-more-button--professional-about',
  BUTTON_SHOW_MORE_EXAMS = 'branch-exams-show-more-button--professional-about',
  BRANCH_PROFILE_SECTION_ADDRESS = 'branch-profile--section-address',
  BRANCH_PROFILE_SECTION_OPENING_HOURS = 'branch-profile--section-opening-hours',
  BRANCH_PROFILE_SECTION_SPECIALTIES = 'branch-profile--section-specialties',
  BRANCH_PROFILE_SECTION_EXAMS = 'branch-profile--section-exams',
  BRANCH_PROFILE_SECTION_PAYMENT_METHODS = 'branch-profile--section-payment-methods',
  BRANCH_PROFILE_SECTION_STRUCTURE = 'branch-profile--section-structure',
  BRANCH_PROFILE_SECTION_SOCIAL_MEDIA = 'branch-profile--section-social-media',
  BRANCH_PROFILE_SECTION_CONTACTS = 'branch-profile--section-contacts',
  BRANCH_PROFILE_SPECIALTIES_LIST = 'branch-specialties--item-list',
  BRANCH_PROFILE_EXAMS_LIST = 'branch-exams--item-list',
  BRANCH_PROFILE_OPENING_HOURS_LIST = 'branch-opening-hours-list',
  BRANCH_CARD = 'branch-card',
  BRANCH_CARD_LINK = 'branch-card-link',
  BRANCH_CONTACT_EMAIL = 'branch-contact--email',
  BRANCH_CONTACT_PHONE = 'branch-contact--phone',
  BRANCH_CONTACT_WHATSAPP = 'branch-contact--whatsapp',
  BRANCH_CONTACT_WHATSAPP_BUTTON = 'branch-contact--whatsapp-button',
  BRANCH_CONTACT_SOCIAL_MEDIA_FACEBOOK = 'branch-contact--social-media-facebook',
  BRANCH_CONTACT_SOCIAL_MEDIA_INSTAGRAM = 'branch-contact--social-media-instagram',
  BRANCH_CONTACT_INFORMATION_CARD = 'branch-contact-information--card',
}
